import React from "react";
import { MapPin, Zap, ArrowRight } from "lucide-react";
import { useContent } from "../contexts/ContentContext";

export default function Projects({ onEnquire }) {
  const { content } = useContent();
  const { projects } = content;
  return (
    <section id="projects" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-12">
          <div className="max-w-2xl">
            <div className="inline-block px-3 py-1 rounded-full bg-emerald-50 text-[#0a4f47] text-xs font-semibold tracking-wider mb-4">
              OUR PROJECTS
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900">
              Solar Installations <span className="text-orange-500">Across India</span>
            </h2>
          </div>
          <button
            onClick={onEnquire}
            className="inline-flex items-center gap-2 text-[#0a4f47] hover:text-orange-600 font-semibold"
          >
            View all projects <ArrowRight className="w-4 h-4" />
          </button>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {projects.map((p, i) => (
            <div
              key={`${p.name}-${p.location}-${i}`}
              className="group relative rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300"
            >
              <div className="absolute top-3 left-3 z-10 px-3 py-1.5 rounded-md bg-white/95 backdrop-blur text-[#0a4f47] text-xs font-bold shadow">
                {p.name}
              </div>
              <div className="absolute top-3 right-3 z-10 px-2.5 py-1 rounded-md bg-orange-500 text-white text-xs font-bold flex items-center gap-1 shadow">
                <Zap className="w-3 h-3" /> {p.capacity}
              </div>
              <img
                src={p.image}
                alt={p.name}
                className="w-full h-72 object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-[#0a3d38]/95 via-[#0a3d38]/60 to-transparent">
                <div className="flex items-center gap-1.5 text-white/90 text-xs">
                  <MapPin className="w-3.5 h-3.5" /> {p.location}
                </div>
                <div className="text-white font-bold text-base mt-1">Residential Rooftop</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
